import { render, staticRenderFns } from "./UnequalAllocationReview.vue?vue&type=template&id=0b9a38cb&scoped=true"
import script from "./UnequalAllocationReview.vue?vue&type=script&lang=js"
export * from "./UnequalAllocationReview.vue?vue&type=script&lang=js"
import style0 from "./UnequalAllocationReview.vue?vue&type=style&index=0&id=0b9a38cb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9a38cb",
  null
  
)

export default component.exports